import React from 'react'

import SearchForm from './SearchForm.js'
import './MainSection.css'

function MainSection () {
  return (
        <>
            <div className='main-container'>
                <h1>COMPANY FINANCIAL HOLDINGS</h1>
                <p>Search 13F Filings by Company Name</p>
                <SearchForm />
            </div>

        </>
  )
}

export default MainSection
